import { mapMutations, mapState } from "vuex";

import ModalTaxInformation from "../../components/ModalTaxInformation/Index-TaxInformation.vue";
import ModalCreateCategory from "../../components/Modals/ModalCreateCategory.vue";
import ModalCreateNcm from "../../components/Modals/ModalCreateNcm.vue";
import InputSelect from "../../components/UI/CustomInputs/InputSelect.vue";
import InputInfinit from "../../components/UI/CustomInputs/InputInfinit.vue";
import InputMoney from "../../components/UI/CustomInputs/InputMoney.vue";
import InputPercentage from "../../components/UI/CustomInputs/InputPercentage.vue";
import toastAlertErros from "../../utils/toastAlertErros";
import ServiceProducts from "../../services/serviceProducts";
import ServiceCategory from "../../services/serviceCategory";
import ServiceTax from "../../services/serviceTax";
import RefFiscalFilters from "../RefFiscalFilters";
import { mascaraMoeda, maskPercentage } from "../../utils/maskMoney";
import { removeSpecialCharacters } from "../../utils/removeSpecialCharacters";
import { HandleErrors } from "../../utils/handleErrors";
import serviceProductLogs from "../../services/serviceProductLogs";
import api from "../../services/axios";
import serviceNcms from "../../services/serviceNcms";
import { unidade } from "../../common/index";
const mixinProducts = {
  mixins: [RefFiscalFilters],
  props: {
    readOrEditProducts: {
      type: Object,
    },
    idProductFromSearch: {
      type: String,
    },
  },
  components: {
    ModalTaxInformation,
    ModalCreateCategory,
    ModalCreateNcm,
    InputSelect,
    InputInfinit,
    InputMoney,
    InputPercentage,
  },
  data() {
    return {
      dataProducts: {
        id: "",
        idCategoria: "",
        nome: "",
        valor: 0.0,
        valorVenda: 0.0,
        margem1: 0,
        lucro: 0,
        unidade: "",
        descricao: "",
        codBarras: "",
        codReferencia: "",
        estoque: 0,
        estoqueMin: 0,
        refFiscal: "",
        cest: "",
        nomeCest: "",
        ncm: "",
        nomeNcm: "",
        status: "Ativo",
        valorDesconto: 0,
        dtValidade: null,
      },
      dataProviderProducts: {
        idFornecedor: "",
        idProduto: "",
        estoque: "",
        valorUnitario: "",
        valorTotal: "",
        descricao: "",
      },
      dataLogsProducts: {
        idProduto: "",
        descricao: "",
        dados: {
          from: "",
          to: "",
        },
      },
      supplierForSelectBox: [],
      refsFiscais: [],
      refsFiscaisFromSelectBox: [],
      createdNewRef: false,
      reloadNcms: false,
      cests: [],
      categories: [],
      stockAdjustmentIsEnable: false,
      stockAmount: 0,
      getProducts: false,
      status: [
        { value: "Ativo", text: "Ativo" },
        { value: "Inativo", text: "Inativo" },
      ],
      compositionIsEnaled: false,
      unidade: unidade,
      desconto: 0,
      tipoDesconto: "Porcentagem",
      discountIsCheked: false,
      isLoading: false,
    };
  },
  methods: {
    async loadRefsFiscaisFromSelectBox() {
      try {
        const result = await ServiceTax.findAllRefs();
        this.refsFiscaisFromSelectBox = result.data.map((ref) => ({
          ...ref,
          descricao: `${ref.ref} - ${ref.descricao}`,
        }));
      } catch (error) {
        this.$toast.open({ message: "Não foi possível carregar as REFs fiscais", type: "error" });
      }
    },
    ...mapMutations([
      "SET_IS_SEARCH_REGISTERS",
      "ALTER_SIZE_MODAL_REGISTER",
      "ALTER_TYPE_REGISTER",
      "SET_COLAPSE_REGISTER",
      "ALTER_MODAL_CONTAINER_REGISTER",
      "SET_DATA_SEARCH_FROM_PRODUCT",
    ]),
    saveOrUpdateProducts() {
      this.dataProducts.id === "" || this.dataProducts.id === null
        ? this.saveProducts()
        : this.updateProducts();
    },

    async updateProducts() {
      try {
        this.isLoading = true;
        await ServiceProducts.updateProducts(this.dataProducts);
        if (this.dataProviderProducts.idFornecedor) {
          await this.assingProviderProduct(this.dataProducts);
        }
        this.$emit("getAllProducts", this.getProducts);
        this.getProducts = !this.getProducts;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Produto Atualizado com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length)
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        else
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
      } finally {
        this.isLoading = false;
      }
    },

    async saveProducts() {
      try {
        this.isLoading = true;
        const id = await ServiceProducts.saveProducts(this.dataProducts);
        this.dataProducts.id = id;
        if (this.dataProviderProducts.idFornecedor) {
          await this.assingProviderProduct(this.dataProducts);
        }

        this.findCestGrupBy();
        this.reloadNcms = !this.reloadNcms;

        this.$emit("getAllProducts", this.getProducts);
        this.getProducts = !this.getProducts;
        this.SET_IS_SEARCH_REGISTERS();
        this.clear();
        return this.$toast.open({
          message: "Produto Salvo com Sucesso",
          type: "success",
        });
      } catch (error) {
        const message = error?.response?.data?.message;

        const typeError = HandleErrors(
          error?.response?.data?.message === "Validation failed"
            ? error?.response?.data?.erros
            : error?.response?.data?.message
        );

        if (message && message.includes("NOT_ALLOWED"))
          return this.$toast.open({
            message: message.split(":")[1],
            type: "info",
          });
        else if (typeError && Object.keys(typeError).length)
          return this.$toast.open({
            message: typeError.message,
            type: "info",
          });
        else if (!isNaN(error.response.data.erros))
          return toastAlertErros.validateErroDoesNotContainFor(
            error,
            this.$toast
          );
        else
          return this.$toast.open({
            message:
              error?.response?.data?.message ||
              "Ocorreu um problema ao registrar o produto!",
            type: "info",
          });
      } finally {
        this.isLoading = false;
      }
    },

    async handleStockAdjustment() {
      this.$bvModal.hide("modal-ajustStock");

      if (!this.dataProducts.id) {
        this.dataProducts.estoque = parseInt(this.stockAmount);
        this.closeStockAdjustment();
      } else {
        if (this.dataProducts.tipoProduto === "agrotoxico") {
          this.closeStockAdjustment();
          return
        }

        this.stockAdjustment();
        this.closeStockAdjustment();
      }
    },

    stockAdjustment() {
      this.dataLogsProducts.dados.from = this.dataProducts.estoque;
      this.dataLogsProducts.dados.to = parseInt(this.stockAmount);
      this.dataProducts.estoque = parseInt(this.stockAmount);
    },

    async assignLogs() {
      this.dataLogsProducts.idProduto = this.dataProducts.id;
      this.dataLogsProducts.descricao = "movManual";

      await serviceProductLogs.save(this.dataLogsProducts);
    },

    enableStockAdjustment() {
      this.stockAdjustmentIsEnable = true;
    },

    closeStockAdjustment() {
      this.stockAdjustmentIsEnable = false;
      this.stockAmount = 0;
    },

    async fillRefsFiscaisComboBoxWithPaginate(id, q, filterType, page, filters = {}) {
      try {
        const result = await ServiceTax.fillComboBoxWithPaginate(id, q, filterType, page, filters);
        return result.map((e) => ({ ...e, nomeRef: `${e.ref} - ${e.descricao}` }));
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar as referências fiscais",
          type: "info",
        });
      }
    },

    async findCestGrupBy() {
      const result = await ServiceProducts.findCestGrupBy();
      this.cests = result;
    },

    async fillNcmComboBoxWithPaginate(id, q, filterType, page) {
      try {
        return await serviceNcms.fillComboBoxWithPaginate(id, q, filterType, page);
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar os ncms do produto",
          type: "info",
        });
      }
    },

    async findAllCategories() {
      try {
        this.categories = await ServiceCategory.fillComobobox();
      } catch (error) {
        this.$toast.open({
          message:
            error?.response?.data?.message ||
            "Ocorreu um problema ao buscar as categorias do produto",
          type: "info",
        });
      }
    },

    async findById(id) {
      const product = await ServiceProducts.getProductById(id);
      return product;
    },

    async handleModalCreateProduct() {
      const product = await this.findById(this.idProductFromSearch);
      this.SET_DATA_SEARCH_FROM_PRODUCT(product);
      this.assingEditProduct();
    },

    clear() {
      this.dataProducts = {
        id: "",
        nome: "",
        valor: 0.0,
        valorVenda: 0.0,
        margem1: 0,
        lucro: 0,
        unidade: "",
        descricao: "",
        codBarras: "",
        codReferencia: "",
        estoque: 0,
        estoqueMin: 0,
        refFiscal: "",
        status: "Ativo",
        idCategoria: "",
        valorDesconto: 0,
      };
      this.desconto = 0;
      this.discountIsCheked = false;
      this.$refs.discount.valueInput = 0;
      this.$refs.valorComDesconto.valueInput = 0;
      this.$refs.refCategories.valueItems = "";
      this.SET_DATA_SEARCH_FROM_PRODUCT({});
    },

    handleNcmOrCest(value, isNcm = false) {
      const formattedValue = removeSpecialCharacters(value);

      if (isNcm) this.dataProducts.ncm = formattedValue;
      else this.dataProducts.cest = formattedValue;

      return formattedValue;
    },

    openModals(name) {
      this.$bvModal.show(name);
    },

    maskCurrency(valor, locale = "pt-BR") {
      if (!valor) {
        valor = 0;
      }
      return parseFloat(valor).toLocaleString(locale, {
        style: "currency",
        currency: "BRL",
      });
    },

    calculateValue(event) {
      this.dataProducts.valor = mascaraMoeda(event?.target?.value ?? event);
      this.calculateSaleFromMargin();
    },

    calculateValueSale(event) {
      this.dataProducts.valorVenda = mascaraMoeda(event?.target?.value ?? event);
      this.synchronizeProfitFromSale();
      this.handleCalculateTotal();
    },

    maskPercentage,

    calculateProfitMargin(event) {
      this.dataProducts.margem1 = mascaraMoeda(event?.target?.value ?? event);
      this.calculateSaleFromMargin();
    },

    calculateSaleFromMargin() {
      const cost = Number(this.dataProducts.valor) || 0;
      const margin = Number(this.dataProducts.margem1) || 0;
      this.dataProducts.lucro = Number((cost * margin / 100).toFixed(2));
      this.dataProducts.valorVenda = Number((cost + this.dataProducts.lucro).toFixed(2));
      this.handleCalculateTotal();
    },

    calculateProfit(event) {
      const cost = Number(this.dataProducts.valor) || 0;
      this.dataProducts.lucro = mascaraMoeda(event?.target?.value ?? event);
      this.dataProducts.valorVenda = Number((cost + this.dataProducts.lucro).toFixed(2));
      this.dataProducts.margem1 = cost > 0
        ? Number((this.dataProducts.lucro / cost * 100).toFixed(2))
        : 0;
      this.handleCalculateTotal();
    },

    synchronizeProfitFromSale() {
      const cost = Number(this.dataProducts.valor) || 0;
      const sale = Number(this.dataProducts.valorVenda) || 0;
      this.dataProducts.lucro = Number((sale - cost).toFixed(2));
      this.dataProducts.margem1 = cost > 0
        ? Number((this.dataProducts.lucro / cost * 100).toFixed(2))
        : 0;
    },

    handleCalculateTotal() {
      let discountValue = 0;
      if (this.discountIsCheked) {
        const result = (
          this.dataProducts.valorVenda *
          (this.desconto / 100)
        ).toFixed(2);

        discountValue = parseFloat(result);
      } else {
        discountValue = this.desconto;
      }
      this.$refs.valorComDesconto.valueInput =
        this.dataProducts.valorVenda - discountValue;
      this.dataProducts.valorDesconto =
        this.dataProducts.valorVenda - discountValue;
    },

    async alterDiscountIsCheked() {
      this.discountIsCheked = !this.discountIsCheked;
      this.handleCalculateTotal();
    },

    assingEditProduct() {
      Object.assign(this.dataProducts, this.dataSearchProduct);
      this.synchronizeProfitFromSale();

      this.$refs.refCategories.valueItems = this.dataSearchProduct.idCategoria;
      this.$refs.valorComDesconto.valueInput = this.dataProducts.valorDesconto;
    },

    async assingProviderProduct(product) {
      this.dataProviderProducts.idProduto = this.dataProducts.id;
      this.dataProviderProducts.valorUnitario = product.valorVenda;
      this.dataProviderProducts.valorTotal = product.valorVenda;
      this.dataProviderProducts.descricao = product.descricao;
      this.dataProviderProducts.estoque = product.estoque;
      await api.post("/products-by-provider", this.dataProviderProducts);
    },

    toggleEnableComposition() {
      this.compositionIsEnaled = !this.compositionIsEnaled;
    },
  },
  watch: {
    readOrEditProducts() {
      this.dataProducts = { ...this.readOrEditProducts, margem1: 0, lucro: 0 };
      this.synchronizeProfitFromSale();
    },
  },
  async mounted() {
    if (this.dataSearchProduct.id || this.dataSearchProduct?.isDuplicate) {
      this.assingEditProduct();
    } else if (this.idProductFromSearch) {
      this.handleModalCreateProduct();
    }

    await this.findCestGrupBy();
    this.findAllCategories();
  },

  computed: {
    ...mapState({
      dataSearchProduct: (state) => state.dataSearchProduct,
    }),
  },
  beforeDestroy() {
    this.clear();
  },
};

export default mixinProducts;
